import styled from 'styled-components';

export const ModalTitle = styled.h3`
  font-weight: normal;
  font-size: 24px;
  line-height: 133.4%;
  color: var(--primaryColor);
`;
export const ModalContent = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 170%;
  color: var(--secondaryColor);
`;
